/* eslint-disable global-require */
import { colors } from "quasar";
import i18n from "@/i18n/index";

export const TASKS_STATUS_NEW = [
    {
        label: i18n.t("tasks.filterBy.overdue"),
        value: "OVERDUE",
        leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#D90000" },
        iconColor: "negative"
    },
    {
        label: i18n.t("tasks.filterBy.inWarning"),
        value: "AT_RISK",
        leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#FB8C00" },
        iconColor: "warning"
    },
    {
        label: i18n.t("tasks.filterBy.attention"),
        value: "ATTENTION",
        leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#FFD600" },
        iconColor: "yellow"
    },
    {
        label: i18n.t("tasks.filterBy.onTime"),
        value: "ON_TRACK",
        leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#14B100" },
        iconColor: "positive"
    }
];

export function getTaskStatus(type) {
    const types = ["ON_TRACK", "ATTENTION", "AT_RISK", "OVERDUE"];
    let returnValue;
    if (types.includes(type)) {
        const isWcag = colors.getBrand("primary") === "#125df3";
        const statuses = {
            ON_TRACK: {
                defaultColor: require("@/assets/images/status-ontime.svg"),
                wcagColor: require("@/assets/images/status-ontime-wcag.svg")
            },
            ATTENTION: {
                defaultColor: require("@/assets/images/status-attention.svg"),
                wcagColor: require("@/assets/images/status-attention-wcag.svg")
            },
            AT_RISK: {
                defaultColor: require("@/assets/images/status-warning.svg"),
                wcagColor: require("@/assets/images/status-warning-wcag.svg")
            },
            OVERDUE: {
                defaultColor: require("@/assets/images/status-overdue.svg"),
                wcagColor: require("@/assets/images/status-overdue-wcag.svg")
            }
        };
        returnValue = statuses[type][isWcag ? "wcagColor" : "defaultColor"];
    } else {
        returnValue = require("@/assets/images/status-default.svg");
    }

    return returnValue;
}

export const TASKS_STATUS_UPDATED = [
    {
        label: i18n.t("tasks.filterBy.overdue"),
        value: "OVERDUE",
        svgIcon: { name: getTaskStatus("OVERDUE") }
    },
    {
        label: i18n.t("tasks.filterBy.inWarning"),
        value: "AT_RISK",
        svgIcon: { name: getTaskStatus("AT_RISK") }
    },
    {
        label: i18n.t("tasks.filterBy.attention"),
        value: "ATTENTION",
        svgIcon: { name: getTaskStatus("ATTENTION") }
    },
    {
        label: i18n.t("tasks.filterBy.onTime"),
        value: "ON_TRACK",
        svgIcon: { name: getTaskStatus("ON_TRACK") }
    }
];

export const TASKS_STATUS = [
    {
        name: "appTasksContainer.overdue",
        id: "OVERDUE",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "negative"
    },
    {
        name: "appTasksContainer.atRisk",
        id: "AT_RISK",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "warning"
    },
    {
        name: "appTasksContainer.attention",
        id: "ATTENTION",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "yellow"
    },
    {
        name: "appTasksContainer.onTrack",
        id: "ON_TRACK",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "positive"
    }
];

export const TASKS_CLAIMED_NEW = [
    {
        label: i18n.t("appTasksContainer.available"),
        value: "onlyAvailable"
    },
    {
        label: i18n.t("appTasksContainer.claimed"),
        value: "onlyClaimed"
    },
    {
        label: i18n.t("appTasksContainer.delegated"),
        value: "onlyDelegated"
    }
];

export const TASKS_CLAIMED = [
    {
        name: "appTasksContainer.available",
        id: "onlyAvailable"
    },
    {
        name: "appTasksContainer.claimed",
        id: "onlyClaimed"
    },
    {
        id: "appTasksContainer.delegated",
        value: "onlyDelegated"
    }
];

export const TASKS_PRIORITY = {
    highest: {
        name: "tasks.filterBy.priorities.highest",
        value: "highest",
        icon: "mdi-chevron-double-up",
        color: "negative"
    },
    high: {
        label: "tasks.filterBy.priorities.high",
        value: "high",
        icon: "mdi-chevron-up",
        color: "negative"
    },
    normal: {
        label: "tasks.filterBy.priorities.normal",
        value: "normal",
        icon: "mdi-minus",
        color: "warning"
    },
    low: {
        label: "tasks.filterBy.priorities.low",
        value: "low",
        icon: "mdi-chevron-down",
        color: "positive"
    },
    lowest: {
        label: "tasks.filterBy.priorities.lowest",
        value: "lowest",
        icon: "mdi-chevron-double-down",
        color: "positive"
    }
};

export const TABLE_DEFAULT_COLUMNS = [
    {
        name: "priority",
        field: "priority"
    },
    {
        name: "taskName",
        field: "taskName"
    },
    {
        name: "instanceName",
        field: "instanceName"
    },
    {
        name: "creationDate",
        field: "creationDate"
    },
    {
        name: "completionDate",
        field: "completionDate"
    },
    {
        name: "assignment",
        field: "assignment"
    },
    {
        name: "status",
        field: "status"
    },
    {
        name: "action",
        field: "action"
    }
];

export const SETTINGS_ACTIONS_BUTTONS = [
    {
        label: "settingsDefault",
        value: "default",
        activeColor: false,
        type: "outline"
    },
    {
        label: "settingsCancel",
        value: "cancel",
        activeColor: false,
        type: "outline"
    },
    {
        label: "settingsConfirm",
        value: "confirm",
        activeColor: true,
        type: "primary"
    }
];

export const SETTINGS_ALL_COLUMNS = ["priority", "instanceName", "creationDate", "assignment", "timeRemaining", "delegatedTo", "delegatedFrom", "status"];

export const SETTINGS_COLUMNS_MY_OPEN = ["priority", "instanceName", "creationDate", "timeRemaining", "delegatedTo", "delegatedFrom", "status"];

export const SETTINGS_COLUMNS_COMPLETED = ["priority", "instanceName", "creationDate", "delegatedTo", "delegatedFrom", "completionDate"];

export const SETTINGS_COLUMNS_TEAMS_COMPLETED = ["priority", "instanceName", "creationDate", "completionDate", "delegatedTo", "delegatedFrom", "assignment"];

export const DEFAULT_COL_SETTINGS_TEAM = ["priority", "creationDate", "assignment", "status"];

export const DEFAULT_COL_SETTINGS_OPEN = ["priority", "creationDate", "status"];

export const DEFAULT_COL_SETTINGS_COMPLETED = ["creationDate", "completionDate"];

export const DEFAULT_COL_SETTINGS_TEAM_COMPLETED = ["completionDate", "assignment"];

export const COMPLETED_TASKS_COMPONENTS = ["completedTasks", "completedTeamsTasks"];

export const PRIORITY_TYPES = {
    highest: require("@/assets/images/highestPriority.svg"),
    high: require("@/assets/images/highPriority.svg"),
    normal: require("@/assets/images/normalPriority.svg"),
    low: require("@/assets/images/lowPriority.svg"),
    lowest: require("@/assets/images/lowestPriority.svg")
};
